const serviceConfig = [
  {
    name: 'telepathology',
    label: 'Telepathology',
  },
  {
    name: 'teleradiology',
    label: 'Teleradiology',
  },
  {
    name: 'government',
    label: 'Government',
  },
  {
    name: 'CASE_TO_CASE_PLAN',
    label: 'Case to Case Services',
  },
];

export default serviceConfig;
